import React, { useState, useRef, useEffect } from "react";
import "./index.scss";
import { Avatar, Box, Button, getColor, Icons, Tooltip, Typography } from "fds";
import { useNavigate } from "react-router-dom";
import WorkgroupManagerIcon from "../WorkgroupManagerIcon";
import { WorkspaceDTO } from "../../redux/store/workspace";
import WorkspaceHomeIcon from "./WorkspaceHomeIcon";
import classNames from "classnames";
interface WorkgroupCardProps {
  item: WorkspaceDTO;
}

const WorkspaceAvatar: React.FC<WorkgroupCardProps> = ({ item }) => {
  const navigate = useNavigate();
  const pickColor = (id: string): any => {
    const colors = [
      "green",
      "deepGreen",
      "cyan",
      "deep_cyan",
      "blue",
      "deep_blue",
      "purple",
      "deep_purple",
      "navy",
    ];
    return colors[(id.charCodeAt(0) + id.charCodeAt(id.length - 1)) % 9];
  };
  const isDisabled =
    item.tenancyStatus === "PAUSE" || item?.allowIpAccess === false;
  const isMainWorkspace = item.dsdCode == "MTECOCOMMON00001";
  const isClicked = window.location.href.includes(item.alias);
  const iSMyDefaultTenancy = item.myDefaultTenancy;
  return (
    <Avatar
      name={item.tenancyName}
      uniqueCode={item.alias}
      color={pickColor(item.alias) ?? "green"}
      shape={"workgroup"}
      size="32"
      style={{ borderRadius: "50%", position: "relative" }}
      opacity={isDisabled ? "20%" : "100%"}
      classes={classNames("workspaceAvatar", {
        clicked: isClicked,
        isDefault: iSMyDefaultTenancy,
      })}
      // onClick={()=> navigate()}
      subIcon={
        isMainWorkspace ? (
          <WorkspaceHomeIcon
            style={{
              position: "absolute",
              bottom: "-3px",
              insetInlineEnd: "-5px",
            }}
          />
        ) : undefined
      }
    />
  );
};
export default WorkspaceAvatar;
